import React, { useState, useEffect, useMemo } from 'react';
import { Modal } from '@mui/material';
import Despesas from '../../Despesas/Despesas';
// import { FormContainer } from '../../styles/styleUtils';

const ModalDespesas = React.forwardRef((props, ref) => {
  return (
    <Modal
      open={props.dateToOpen}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
        <>
        <div style={{height: 100}} />
        <Despesas dateToOpen={props.dateToOpen}/>
        </>
        
      
    </Modal>
  );
});

/*
AddProposta.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
}
*/

export default ModalDespesas;
